import { type QueryClient, queryOptions } from '@tanstack/react-query'
import { apiGet, unwrap } from '@/shared/api'
import type { PomodoroSettings, PomodoroStateView } from '../model/schema'
import { type PomodoroStateDto, toPomodoroState } from './mappers'

export const pomodoroKeys = {
  all: ['pomodoro'] as const,
  state: () => [...pomodoroKeys.all, 'state'] as const,
}

// Сессия + настройки одним запросом. Поллинг 30с (docs/design §4): при открытой
// вкладке синхронизирует смену фазы, которую двигает воркер (в mock — авто-перекат
// в GET). Дрейф клиентского обратного отсчёта тоже подтягивается.
export const pomodoroQueryOptions = queryOptions({
  queryKey: pomodoroKeys.state(),
  queryFn: async (): Promise<PomodoroStateView> =>
    toPomodoroState(unwrap<PomodoroStateDto>(await apiGet('/pomodoro'))),
  refetchInterval: 30_000,
})

// Патч настроек в state-кэше (оптимистика фичи pomodoro-settings); сессию не трогаем.
export function patchPomodoroSettings(
  qc: QueryClient,
  patch: Partial<Pick<PomodoroSettings, 'workMinutes' | 'breakMinutes'>>,
): void {
  qc.setQueryData<PomodoroStateView>(pomodoroKeys.state(), (prev) =>
    prev ? { ...prev, settings: { ...prev.settings, ...patch } } : prev,
  )
}
